// extracted by mini-css-extract-plugin
module.exports = {"pages":"index_pages__2CbMX","select":"index_select__1Y3MO","option":"index_option__AA0F9"};